import { useUpAuth } from "../components/authentication/UpAuth"
import LoadingUpAnimation from "../components/LoadingUpAnimation";
import PrivateHomePage from "./PrivateHomePage";
import PublicHomepage from "./PublicHomepage/PublicHomepage";

const Homepage = ({ defaultTabIndex }: { defaultTabIndex: number }) => {
  const { isAuthenticated, upAuthLoading } = useUpAuth();

  if (upAuthLoading) {
    return <LoadingUpAnimation />
  }

  if (!isAuthenticated) {
    return <PublicHomepage />
  }

  return (
    <PrivateHomePage defaultTabIndex={defaultTabIndex} />
  )
}

export default Homepage